import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Highcharts from 'highcharts';
import { ScatterchartService } from '../../scatterchart.service';
import HC_accessibility from 'highcharts/modules/accessibility';
import HC_3D from 'highcharts/highcharts-3d';
// import { sign } from 'crypto';
import { Observable } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';

@Component({
  selector: 'app-scatterchart01',
  templateUrl: './scatterchart01.component.html',
  styleUrls: [],
})
export class Scatterchart01ComponentCustom implements OnInit {
  constructor(private http: HttpClient, private ss: ScatterchartService,  private _customSnapshotService:CustomsnapshotService) {}

  chart: any;
  data: any;
  color: any;
  chartproperties: any;
  seriesdata: any;
  imageseriesdata: any;
  image1: any;
  jsondata: any;
  sampleSizeConstandValue = 9000;
  title: any;

  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any=0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any="24em";

  ngOnInit(): void {
    this.http
      .get<any>('assets/Data/scatterData.json')
      .subscribe((data: any) => {
        const dataJson = data[0];
        this.jsondata = dataJson;
        this.data = dataJson['data'];
        this.chartproperties = dataJson['properties'][0];
        this.chartproperties.showLegend=true;
        this.title = dataJson['title'];
        this.color = this.ss.color;
        this.image1 = this.data.map((brandData: any) => brandData.image);

        HC_3D(Highcharts);
        this.generatechart(
          'chart-container',
          this.data,
          this.chartproperties,
          this.seriesdata
        );
      });
  }
  

  chartData(data: any, markerSymbol: any) {
    this.seriesdata = data.map((i: any, index: any) => {
      return {
        name: i.brand,
        marker: {
          symbol:
            markerSymbol != 'image'
              ? markerSymbol
              : `url(${this.ss.baseImgPath + i.image + '.png'})`,
          radius: 5,
          width: 10,
          height: 10,
        },
        color: this.color[index],
        data: i.data.map((point: any) => ({
          x:
            this.chartproperties.datalabelStyle === 'ls' &&
            point['Sample size'] < this.sampleSizeConstandValue
              ? 0
              : point.x,

          y:
            this.chartproperties.datalabelStyle === 'ls' &&
            point['Sample size'] < this.sampleSizeConstandValue
              ? 0
              : Number(parseFloat(point.y).toFixed(this.chartproperties.decimalRoundOff)),
          metric: point.metric,
          significance: point.Significance,
          significance2: point.Significance2,
          cv: point['ChangeVs'],
          samplesize: point['Sample size'],
        })) as { x: number; y: number; metric: string }[],
      };
    });
  }

  generatechart(container: any, data: any, properties: any, seriesData: any) {
    localStorage.setItem('properties', JSON.stringify(properties));
    HC_accessibility(Highcharts);
    this.chartData(data, properties.markerStyle);
    const containerEl = document.getElementById(container);
    if (!containerEl) { return; }
    this.chart = Highcharts.chart(containerEl, {
      accessibility: {},
      chart: {
        type: 'scatter',
        backgroundColor: this.chartproperties.darkTheme ? '#333' : 'white',
        renderTo: 'chart-container',
        zoomType: 'xy',
        style:{
          fontFamily:this.ss.fontFamily,
        },
        options3d: {
          enabled: properties.is3D,
          alpha: -1,
          beta: -1,
          depth: 190,
          viewDistance: 4,
          fitToPlot: false,
        },
      },
      title: {
        text: "",
        align: properties.chartTitlePosition,
        verticleAlign: 'top',
        style: {
          color: properties.darkTheme ? 'white' : 'black',
        },
      },
      legend: {
        enabled: properties.showLegend,
        layout:
          properties.legendPosition !== 'bottom' ? 'vertical' : 'horizontal',
        verticalAlign:
          properties.legendPosition !== 'bottom' ? 'middle' : 'bottom',
        align:
          properties.legendPosition === 'bottom'
            ? 'center'
            : properties.legendPosition,
        itemStyle: {
          color: properties.darkTheme ? 'white' : 'black',
          fontWeight: 'normal',
          fontSize: '0.8em',
        },
      },
      plotOptions: {
        series:{
          animation: false
        },
        scatter: {
          dataLabels: {
            enabled: properties.showDataLabel,
            allowOverlap: true,
            style: {
              fontSize: properties.dataLabelSize,
              color:
                properties.dataLabelColor == 'Default'
                  ? properties.darkTheme
                    ? 'white'
                    : 'black'
                  : properties.dataLabelColor,
              fontWeight: 'none',
              textOutline: 'none',
            },

            formatter: function (
              this: Highcharts.TooltipFormatterContextObject
            ) {
              const pointWithMetric = this.point as {
                x: number;
                y: number;
                metric?: string;
                cv?: string;
                significance?: string;
                significance2?: string;
                samplesize?: number;
              };

              if (pointWithMetric.metric) {
                let tooltipContent = '';

                if (properties.datalabelFormat === 'number') {
                  if (properties.datalabelStyle === 'change') {
                    return `<span style="color:${properties.dataLabelColor};">${
                      pointWithMetric.x
                    } , ${
                      pointWithMetric.y
                    } <span style="font-size: 80%; color: ${
                      properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                  } else if (properties.datalabelStyle === 'significance') {
                    tooltipContent = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                  } else if (
                    properties.datalabelStyle === 'significance + changeVs'
                  ) {
                    tooltipContent = `<span style="color:${
                      properties.dataLabelColor
                    };">${pointWithMetric.x} , ${
                      pointWithMetric.y
                    } <span style="font-size: 80%; color: ${
                      properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                  } else if (properties.datalabelStyle == 'significance2') {
                    let color =
                      pointWithMetric.significance2 === '1'
                        ? 'green'
                        : pointWithMetric.significance2 === '-1'
                        ? 'red'
                        : properties.darkTheme
                        ? 'white'
                        : 'black';

                    const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                    tooltipContent = `<span style="color:${
                      properties.dataLabelColor
                    };">${pointWithMetric.x} , ${
                      pointWithMetric.y
                    } <span  style="font-size: 80%;color: ${
                      properties.darkTheme ? 'white' : 'black'
                    };">(${significance2Content})</span>  </span>`;
                  } else if (properties.datalabelStyle === 'ls') {
                    const metricValue: string = pointWithMetric.metric;

                    if (
                      pointWithMetric.samplesize &&
                      pointWithMetric.samplesize < 9000
                    ) {
                      return 'LS';
                    }

                    return `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                  } else {
                    const metricValue: string = pointWithMetric.metric;
                    return `<span>${metricValue}<br>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                  }
                }

                if (properties.datalabelFormat === 'percentage') {
                  if (properties.datalabelStyle === 'change') {
                    return `<span style="color:${properties.dataLabelColor};">${
                      pointWithMetric.x
                    }% , ${
                      pointWithMetric.y
                    }% <span style="font-size: 80%; color: ${
                      properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                  } else if (properties.datalabelStyle === 'significance') {
                    tooltipContent = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                  } else if (properties.datalabelStyle == 'significance2') {
                    let color =
                      pointWithMetric.significance2 === '1'
                        ? 'green'
                        : pointWithMetric.significance2 === '-1'
                        ? 'red'
                        : properties.darkTheme
                        ? 'white'
                        : 'black';
                    const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                    tooltipContent = `<span style="color:${
                      properties.dataLabelColor
                    };">${pointWithMetric.x}% , ${
                      pointWithMetric.y
                    }% <span  style="font-size: 80%;color: ${
                      properties.darkTheme ? 'white' : 'black'
                    };">(${significance2Content})</span>  </span>`;
                  } else if (
                    properties.datalabelStyle === 'changeversus+significance'
                  ) {
                    tooltipContent = `<span style="color:${
                      properties.dataLabelColor
                    };">${pointWithMetric.x}% , ${
                      pointWithMetric.y
                    }% <span style="font-size: 80%; color: ${
                      properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                  } else if (properties.datalabelStyle === 'ls') {
                    if (
                      pointWithMetric.samplesize &&
                      pointWithMetric.samplesize < 9000
                    ) {
                      return 'LS';
                    }

                    return `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                  } else {
                    const metricValue: string = pointWithMetric.metric;
                    return `<span>${metricValue}<br>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                  }
                }

                if (pointWithMetric.significance === '1') {
                  tooltipContent +=
                    '<span style="color: green;"> &#9650;</span>';
                } else if (pointWithMetric.significance === '-1') {
                  tooltipContent += '<span style="color: red;"> &#9660;</span>';
                } else {
                  tooltipContent += '';
                }

                return tooltipContent;
              } else {
                return `<span>${this.series.name}<br>X: ${pointWithMetric.x}, Y: ${pointWithMetric.y}</span>`;
              }
            },
          },

          marker: {
            radius: 5,
            width: 10,
            height: 10,
            states: {
              hover: {
                enabled: true,
                lineColor: 'rgb(100,100,100)',
              },
            },
          },
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
      xAxis: {
        title: {
          text: '',
          style: {
            color: properties.darkTheme ? 'white' : 'black',
          },
        },
        labels: {
          rotation:this.chartproperties.axisLabelOrientation==='vertical'?-90:(this.chartproperties.axisLabelOrientation==='angled'?-45:0),
          format:
            properties.datalabelFormat == 'percentage' ? '{value}%' : '{value}',
          style: {
            color: properties.darkTheme ? 'white' : 'black',
          },
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true,
        lineWidth: 1,
        gridLineWidth: properties.gridlines === true ? 1 : 0,
      },
      yAxis: {
        title: {
          text: '',
          style: {
            color: properties.darkTheme ? 'white' : 'black',
          },
        },
        labels: {
          rotation:this.chartproperties.yaxisLabelOrientation==='vertical'?-90:(this.chartproperties.yaxisLabelOrientation==='angled'?-45:0),
          format:
            properties.datalabelFormat == 'percentage' ? '{value}%' : '{value}',
          style: {
            color: properties.darkTheme ? 'white' : 'black',
          },
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true,
        tickWidth: 1,
        lineWidth: 1,
        gridLineWidth: properties.gridlines === true ? 1 : 0,
      },
      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        shape: properties.toolTipStyle == 'style1' ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',

        formatter: function (this: Highcharts.TooltipFormatterContextObject) {
          const pointWithMetric = this.point as {
            x: number;
            y: number;
            metric?: string;
            cv?: string;
            significance?: string;
            significance2?: string;
            samplesize?: any;
          };

          let isDefaultTooltip = properties.toolTipStyle;
          // if (isDefaultTooltip == 'style1') {
          //   const dotColor = this.series.color;
          // const commonContent =
          //   `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color: white;">` +
          //   `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
          //   `<span><strong>Series Name:</strong></span> ${pointWithMetric.metric}<br>` +
          //   `<span><strong>Category Name:</strong></span> ${this.series.name}<br>` +
          //   `<span><strong>x value:</strong></span> ${this.point.x}<br>` +
          //   `<span><strong>y value:</strong></span> ${this.point.y}`;

          // return commonContent + '</div>';
          // }
          if (isDefaultTooltip == 'style1') {
            const dotColor = this.series.color;
            let tooltipContent = '';
            let tooltip = '';

            if (properties.datalabelFormat === 'number') {
              if (properties.datalabelStyle === 'changeversus') {
                tooltip = `<span style="color:${properties.dataLabelColor};">${
                  pointWithMetric.x
                } , ${pointWithMetric.y} <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${pointWithMetric.cv})</span></span>`;
              } else if (properties.datalabelStyle === 'significance') {
                tooltipContent = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
              } else if (
                properties.datalabelStyle === 'changeversus+significance'
              ) {
                tooltipContent = `<span style="color:${
                  properties.dataLabelColor
                };">${pointWithMetric.x} , ${
                  pointWithMetric.y
                } <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${pointWithMetric.cv})</span></span>`;
              } else if (properties.datalabelStyle == 'significance2') {
                let color =
                  pointWithMetric.significance2 === '1'
                    ? 'green'
                    : pointWithMetric.significance2 === '-1'
                    ? 'red'
                    : properties.darkTheme
                    ? 'white'
                    : 'black';
                const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                tooltipContent = `<span style="color:${
                  properties.dataLabelColor
                };">${pointWithMetric.x} , ${
                  pointWithMetric.y
                } <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${significance2Content})</span></span>`;
              } else if (properties.datalabelStyle === 'ls') {
                if (
                  pointWithMetric.samplesize &&
                  pointWithMetric.samplesize < 9000
                ) {
                  tooltip = 'LS';
                } else {
                  tooltip = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                }
              } else {
                const metricValue: any = pointWithMetric.metric;
                tooltip = `<span>${metricValue}<br>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
              }
            }

            if (properties.datalabelFormat === 'percentage') {
              if (properties.datalabelStyle === 'changeversus') {
                tooltip = `<span style="color:${properties.dataLabelColor};">${
                  pointWithMetric.x
                }% , ${
                  pointWithMetric.y
                }% <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${pointWithMetric.cv})</span></span>`;
              } else if (properties.datalabelStyle === 'significance') {
                tooltipContent = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
              } else if (properties.datalabelStyle == 'significance2') {
                let color =
                  pointWithMetric.significance2 === '1'
                    ? 'green'
                    : pointWithMetric.significance2 === '-1'
                    ? 'red'
                    : properties.darkTheme
                    ? 'white'
                    : 'black';
                const significance2Content = `<span style="color: ${color};">${pointWithMetric.cv}</span>`;
                tooltipContent = `<span style="color:${
                  properties.dataLabelColor
                };">${pointWithMetric.x}% , ${
                  pointWithMetric.y
                }% <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${significance2Content})</span></span>`;
              } else if (
                properties.datalabelStyle === 'changeversus+significance'
              ) {
                tooltipContent = `<span style="color:${
                  properties.dataLabelColor
                };">${pointWithMetric.x}% , ${
                  pointWithMetric.y
                }% <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${pointWithMetric.cv})</span></span>`;
              } else if (properties.datalabelStyle === 'ls') {
                if (
                  pointWithMetric.samplesize &&
                  pointWithMetric.samplesize < 9000
                ) {
                  tooltip = 'LS';
                } else {
                  tooltip = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                }
              } else {
                const metricValue: any = pointWithMetric.metric;
                tooltip = `<span>${metricValue}<br>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
              }
            }

            if (pointWithMetric.significance === '1') {
              tooltipContent += '<span style="color: green;"> &#9650;</span>';
            } else if (pointWithMetric.significance === '-1') {
              tooltipContent += '<span style="color: red;"> &#9660;</span>';
            }

            let tooltip1 =
              properties.datalabelStyle === 'ls' ||
              properties.datalabelStyle === 'changeversus' ||
              properties.datalabelStyle === 'default'
                ? tooltip
                : tooltipContent;
            const commonContent =
              `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color: white;">` +
              `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
              `<span><strong>Series Name:</strong></span> ${pointWithMetric.metric}<br>` +
              `<span><strong>Category Name:</strong></span> ${this.series.name}<br>` +
              ` ${tooltip1}<br>`;

            return commonContent + '</div>';
          } else {
            // const dotColor = this.series.color; // Get the series color
            // const content =
            //   `<div style="background-color: #f5f5f5; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
            //   `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"></div>` +
            //   ` ${this.series.name}` +
            //   `<div style="display: block; margin-top: 5px;"><strong>x value:</strong> ${this.point.x}</div>` +
            //   `<div style="display: block; margin-top: 5px;"><strong>y value:</strong> ${this.point.y}</div>`;

            // return content + '</div>';

            const dotColor = this.series.color;
            let tooltipContent = '';
            let tooltip = '';

            if (properties.datalabelFormat === 'number') {
              if (properties.datalabelStyle === 'changeversus') {
                tooltip = `<span style="color:${properties.dataLabelColor};">${
                  pointWithMetric.x
                } , ${pointWithMetric.y} <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${pointWithMetric.cv})</span></span>`;
              } else if (properties.datalabelStyle === 'significance') {
                tooltipContent = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
              } else if (
                properties.datalabelStyle === 'changeversus+significance'
              ) {
                tooltipContent = `<span style="color:${
                  properties.dataLabelColor
                };">${pointWithMetric.x} , ${
                  pointWithMetric.y
                } <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${pointWithMetric.cv})</span></span>`;
              } else if (properties.datalabelStyle == 'significance2') {
                let color =
                  pointWithMetric.significance2 === '1'
                    ? 'green'
                    : pointWithMetric.significance2 === '-1'
                    ? 'red'
                    : properties.darkTheme
                    ? 'white'
                    : 'black';
                const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                tooltipContent = `<span style="color:${
                  properties.dataLabelColor
                };">${pointWithMetric.x} , ${
                  pointWithMetric.y
                } <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${significance2Content})</span></span>`;
              } else if (properties.datalabelStyle === 'ls') {
                if (
                  pointWithMetric.samplesize &&
                  pointWithMetric.samplesize < 9000
                ) {
                  tooltip = 'LS';
                } else {
                  tooltip = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                }
              } else {
                const metricValue: any = pointWithMetric.metric;
                tooltip = `<span>${metricValue}<br>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
              }
            }

            if (properties.datalabelFormat === 'percentage') {
              if (properties.datalabelStyle === 'changeversus') {
                tooltip = `<span style="color:${properties.dataLabelColor};">${
                  pointWithMetric.x
                }% , ${
                  pointWithMetric.y
                }% <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${pointWithMetric.cv})</span></span>`;
              } else if (properties.datalabelStyle === 'significance') {
                tooltipContent = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
              } else if (properties.datalabelStyle == 'significance2') {
                let color =
                  pointWithMetric.significance2 === '1'
                    ? 'green'
                    : pointWithMetric.significance2 === '-1'
                    ? 'red'
                    : properties.darkTheme
                    ? 'white'
                    : 'black';
                const significance2Content = `<span style="color: ${color};">${pointWithMetric.cv}</span>`;
                tooltipContent = `<span style="color:${
                  properties.dataLabelColor
                };">${pointWithMetric.x}% , ${
                  pointWithMetric.y
                }% <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${significance2Content})</span></span>`;
              } else if (
                properties.datalabelStyle === 'changeversus+significance'
              ) {
                tooltipContent = `<span style="color:${
                  properties.dataLabelColor
                };">${pointWithMetric.x}% , ${
                  pointWithMetric.y
                }% <span style="font-size: 80%; color: ${
                  properties.darkTheme ? 'white' : 'black'
                };">(${pointWithMetric.cv})</span></span>`;
              } else if (properties.datalabelStyle === 'ls') {
                if (
                  pointWithMetric.samplesize &&
                  pointWithMetric.samplesize < 9000
                ) {
                  tooltip = 'LS';
                } else {
                  tooltip = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                }
              } else {
                const metricValue: any = pointWithMetric.metric;
                tooltip = `<span>${metricValue}<br>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
              }
            }

            if (pointWithMetric.significance === '1') {
              tooltipContent += '<span style="color: green;"> &#9650;</span>';
            } else if (pointWithMetric.significance === '-1') {
              tooltipContent += '<span style="color: red;"> &#9660;</span>';
            }

            let tooltip1 =
              properties.datalabelStyle === 'ls' ||
              properties.datalabelStyle === 'changeversus' ||
              properties.datalabelStyle === 'default'
                ? tooltip
                : tooltipContent;
            const content =
              `<div style="background-color: #f5f5f5; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"></div>` +
              ` ${this.series.name}<br>` +
              ` ${tooltip1}<br>`;

            return content + '</div>';
          }
        },
      },
      series: this.seriesdata,
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
    } as any);
  }


  customization(): Observable<any[]> { 
    return this._customSnapshotService.getChartCustomization("Scatter Chart",this._customSnapshotService.selectedSnapshotType?.name);
 
   }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.ss.applycustomization(event,item, this.chartproperties)
    this.generatechart(
      'chart-container',
      this.data,
      this.chartproperties,
      this.seriesdata
    );
    }

  userselectedproperties() {
    this.jsondata['properties'][0] = this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
